export const ERROR_LABELS = {
    REQUIRED: {
        EMAIL: 'Email is required.',
        PASSWORD: 'Password is required.'
    }
};